import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Qu'est-ce que MeMed BV® et en quoi diffère-t-il des tests classiques ?",
    a: "Contrairement aux tests qui recherchent directement un virus ou une bactérie, MeMed BV® analyse la réponse immunitaire du patient. Il mesure trois protéines — TRAIL, IP-10 et CRP — combinées par un algorithme propriétaire qui produit un score indiquant la probabilité d'une infection bactérienne ou virale.",
  },
  {
    q: "En combien de temps obtient-on un résultat ?",
    a: "Le résultat est disponible en environ 15 minutes directement sur la plateforme MeMed Key®, au point de prise en charge du patient.",
  },
  {
    q: "Quels sont les bénéfices pour les services d'urgences ?",
    a: "MeMed BV® aide à réduire l'incertitude diagnostique dès l'arrivée du patient, à éviter des prescriptions antibiotiques inutiles, à limiter certains examens complémentaires et hospitalisations évitables, et à fluidifier les parcours patients.",
  },
  {
    q: "MeMed BV® est-il approprié en pédiatrie ?",
    a: "Oui. Le test a été validé chez l'enfant à travers plusieurs études multicentriques (OPPORTUNITY, Apollo, études en urgences pédiatriques). Il représente un outil clé pour soutenir le bon usage des antibiotiques chez l'enfant.",
  },
  {
    q: "Quel est l'impact sur l'antibiorésistance ?",
    a: "Les études montrent que MeMed BV® contribue à réduire les prescriptions antibiotiques inutiles dans une large majorité des situations où une hésitation diagnostique est présente — un levier concret pour les programmes d'Antibiotic Stewardship.",
  },
  {
    q: "Existe-t-il une évaluation médico-économique ?",
    a: "Oui. Une modélisation portant sur 1 000 patients présentant une suspicion de pneumonie communautaire a estimé des économies d'environ 157 000 € chez l'adulte et 124 000 € chez l'enfant (Gregg et al., 2025, JAC-Antimicrobial Resistance).",
  },
  {
    q: "Comment intégrer MeMed Key® dans notre établissement ?",
    a: "Nexodiag accompagne l'intégration de la solution dans votre organisation : démonstration, validation technique, formation des équipes et accompagnement à la mise en service. Contactez-nous pour planifier une démo.",
  },
];

const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <div className="text-center mb-14 nx-fade">
          <div className="text-xs uppercase tracking-[0.2em] text-[#5BC4D1] font-medium mb-4">
            Questions fréquentes
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-tight tracking-tight">
            Tout ce qu&apos;il faut <span className="font-semibold">savoir.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[#0E1530] border border-white/10 rounded-2xl px-5 data-[state=open]:border-[#5BC4D1]/40 transition-colors"
            >
              <AccordionTrigger className="text-left text-white hover:text-[#5BC4D1] hover:no-underline font-medium py-5 [&[data-state=open]>svg]:text-[#5BC4D1]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-300 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
